import { TCostTrendData } from 'types/models/DataAnalysis'
import { generateStaticColor } from '../../utils/wheatCodeColors'

export const toCostTrendChartData = (
  arr: TCostTrendData[]
): { rows: any[]; series: { key: string; name: string; color: string }[] } => {
  if (!Array.isArray(arr)) return { rows: [], series: [] }

  const dateMap: Record<string, any> = {}
  const blendTypes = new Set<string>()

  arr.forEach((item) => {
    if (!dateMap[item.date]) dateMap[item.date] = { period: item.date }
    dateMap[item.date][item.blend_type] = item.cost
    blendTypes.add(item.blend_type)
  })

  const blendEntities = Array.from(blendTypes).map((blend) => ({
    id: blend,
    name: blend,
  }))

  const colorMap = generateStaticColor(blendEntities)

  const series = Array.from(blendTypes).map((blend) => ({
    key: blend,
    name: blend,
    color: colorMap[blend],
  }))

  return { rows: Object.values(dateMap), series }
}
